import { useContext } from 'react';
import { StyledHeader, StyledHeaderRow, StyledTitle } from './Header.style';
import MetricsInspectionContext from '../state/context';
import Filters from './Filters/Filters';
import Actions from './Actions/Actions';

const Header = () => {
  const { state } = useContext(MetricsInspectionContext);
  const widgetName = state?.widget?.name;

  return (
    <StyledHeader>
      <StyledHeaderRow>
        <div className='max-w-[calc(100%-25rem)] overflow-hidden'>
          <StyledTitle>{widgetName}</StyledTitle>
          <Filters />
        </div>
        <Actions className='max-w-[25rem]' />
      </StyledHeaderRow>
    </StyledHeader>
  );
};

export default Header;
